import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const EducationalCenterGradingRepository = {
  saveEducationalCenterGrading: (vacancyAppId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalCenterGrading/vacancyApplication/${vacancyAppId}`,
      method: "POST",
      data: data,
    });
  },

  getEducationalCenterGrading: (vacancyAppId) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalCenterGrading/vacancyApplication/${vacancyAppId}`,
      method: "GET",
    });
  },

  uploadFile: (vacancyAppId, file) => {
    const data = new FormData();
    data.append("file", file);
    return Axios({
      url: `${SETTINGS.API_URL}educationalCenterGrading/vacancyApplication/${vacancyAppId}/attachments`,
      method: "PUT",
      data: data,
    });
  },

  deleteFile: (vacancyAppId, attachmentId) => {
    return Axios({
      url: `${SETTINGS.API_URL}educationalCenterGrading/vacancyApplication/${vacancyAppId}/attachments/${attachmentId}`,
      method: "DELETE",
    });
  },
};
